import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  isLoading = new BehaviorSubject<boolean>(false);

  constructor() {}

  changeLoadingStatus(status: boolean) {
    this.isLoading.next(status);
  }
}
